import ky from "ky";

export const kyClient = ky.create({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
